import React from 'react'
import { Box, BoxProps, SxProps, Theme, styled } from '@mui/material'
import { colors } from '../../themes/colors'

const BGSection = styled('section')`
  display: grid;
  gap: 24px;
  width: 100%;
  ::before {
    z-index: -1;
    content: '';
    left: ${-window.outerWidth}px;
    right: ${-window.outerWidth}px;
    top: ${-window.outerHeight}px;
    bottom: 0;
    position: absolute;
    background-color: ${colors.primary100};
  }
`

interface Props extends BoxProps {
  children: React.ReactNode[] | React.ReactNode
  sx?: SxProps<Theme>
}

const Section: React.FC<Props> = ({ sx, children, ...props }) => {
  return (
    <Box display='flex' position='relative' {...props}>
      <BGSection sx={sx}>{children}</BGSection>
    </Box>
  )
}
export default Section
